import apiClient from "@/lib/api";
import type { PaginationMeta } from "./jobHuntingFiles";

export interface TargetPosition {
  id: string;
  company_name: string;
  industry_id: string | null;
  job_title: string | null;
  job_description: string | null;
  created_at: string;
  updated_at: string;
}

export interface TargetPositionsListResponse {
  items: TargetPosition[];
  meta: PaginationMeta;
}

export interface ListParams {
  page?: number;
  per_page?: number;
}

export interface TargetPositionPayload {
  company_name: string;
  industry_id?: string | null;
  job_title?: string | null;
  job_description?: string | null;
}

export async function listTargetPositions(
  params: ListParams = {}
): Promise<TargetPositionsListResponse> {
  const res = await apiClient.get<TargetPositionsListResponse>(
    "/target_positions",
    { params }
  );
  return res.data;
}

export async function createTargetPosition(
  payload: TargetPositionPayload
): Promise<TargetPosition> {
  const res = await apiClient.post<TargetPosition>("/target_positions", {
    target_position: payload,
  });
  return res.data;
}

export async function updateTargetPosition(
  id: string,
  payload: TargetPositionPayload
): Promise<TargetPosition> {
  const res = await apiClient.patch<TargetPosition>(
    `/target_positions/${id}`,
    { target_position: payload }
  );
  return res.data;
}

export async function deleteTargetPosition(id: string): Promise<void> {
  await apiClient.delete(`/target_positions/${id}`);
}

export async function fetchTargetPosition(id: string): Promise<TargetPosition> {
  const res = await apiClient.get<TargetPosition>(`/target_positions/${id}`);
  return res.data;
}
